import { render, staticRenderFns } from "./CategoryChildren.vue?vue&type=template&id=47cfc2ba&scoped=true&"
import script from "./CategoryChildren.vue?vue&type=script&lang=js&"
export * from "./CategoryChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cfc2ba",
  null
  
)

export default component.exports